// The offline indicator in the root layout (FR-040; US6-1).
import { StyleSheet, View } from "react-native";

import { makeStyles } from "@/theme/makeStyles";
import { Text } from "@/ui/Text";

import { useNetworkStatus } from "./useNetworkStatus";

export const OFFLINE_MESSAGE =
  "You're offline. Some things may not load until you reconnect.";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    banner: {
      paddingHorizontal: t.space.lg,
      paddingVertical: t.space.sm,
      backgroundColor: t.color.offline,
      alignItems: "center",
    },
    text: { color: t.color.offlineText, textAlign: "center" },
  }),
);

export function OfflineBanner() {
  const styles = useStyles();
  const { online } = useNetworkStatus();
  if (online) return null;
  return (
    <View
      style={styles.banner}
      testID="offline-banner"
      role="status"
      aria-live="polite"
    >
      <Text size="sm" weight="medium" style={styles.text}>
        {OFFLINE_MESSAGE}
      </Text>
    </View>
  );
}
